import React from "react";
import "../assets/public/css/font-awesome.min.css";
import "../assets/public/css/style.css";
import "../assets/public/css/auth.css";
import "../assets/public/css/responsive.css";

export default function AuthTheme({ children }) {
  return <>{children}</>;
}
